export type PanelSize = number | string;

// react-resizable-panels v4 treats bare numbers as pixels; bare strings as percentages.
// Our codebase historically used numbers as percentages, so map numbers to "<n>%".
export const toPanelSize = (size?: PanelSize): string | undefined => {
  if (size === undefined) {
    return undefined;
  }

  return typeof size === 'number' ? `${size}%` : size;
};
